module.exports = __webpack_public_path__ + "static/vf_msneakers_core.42e67126.svg";